import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Logo({ className = "h-9" }) {
  const { user } = useAuth();
  return (
    <Link
      to={user ? "/dashboard" : "/"}
      data-testid="brand-logo"
      className="inline-flex items-center"
      aria-label="HK ForexEdge home"
    >
      <img src="/logo.png" alt="HK ForexEdge" className={`${className} w-auto`} />
    </Link>
  );
}
